import { useSelector } from 'react-redux';
import React from 'react';

import CreateRecordDialog from './CreateRecordDialog';
import EditRecordDialog from './EditRecordDialog';

import {
  selectClockOutRecordDialogOpen,
  selectCreateRecordDialogOpen,
  selectEditRecordDialogOpen,
  selectIsCreateAbsenceDialogOpen,
  selectLocationMustDialog,
  selectProximityToClockInRequiredDialog,
} from 'store/records/selectors/records.selectors';
import LocationMust from 'components/LocationMust/LocationMust';
import ClockOutRecordDialog from 'components/ClockOutDialog/ClockOutRecordDialog';
import { selectIsRecordAlreadyClockedInDialogOpen } from 'store/records/selectors/records-base.selectors';
import { RecordAlreadyClockedInDialog } from 'components/RecordAlreadyClockedInDialog/RecordAlreadyClockedInDialog';
import { CreateAbsenceDialog } from './CreateAbsenceDialog';
import ProximityToClockInRequiredDialog from 'components/ProximityToClockInRequiredDialog/ProximityToClockInRequiredDialog';

function RecordDialogContainer() {
  const editRecordDialogOpen = useSelector(selectEditRecordDialogOpen);

  const createRecordDialogOpen = useSelector(selectCreateRecordDialogOpen);
  const isCreateAbsenceDialogOpen = useSelector(
    selectIsCreateAbsenceDialogOpen
  );
  const clockOutRecordDialogOpen = useSelector(selectClockOutRecordDialogOpen);

  const isRecordAlreadyClockedInDialogOpen = useSelector(
    selectIsRecordAlreadyClockedInDialogOpen
  );

  const locationMustProject = useSelector(selectLocationMustDialog);

  const proximityToClockInRequiredDialogProject = useSelector(
    selectProximityToClockInRequiredDialog
  );

  const locationMustOpen = locationMustProject ? true : false;

  const proximityToClockInRequiredDialogOpen = proximityToClockInRequiredDialogProject ? true : false;


  return (
    <>
      {editRecordDialogOpen ? (
        <EditRecordDialog open={editRecordDialogOpen} />
      ) : null}
      {createRecordDialogOpen ? (
        <CreateRecordDialog open={createRecordDialogOpen} />
      ) : null}
      {isCreateAbsenceDialogOpen ? <CreateAbsenceDialog /> : null}
      {clockOutRecordDialogOpen ? (
        <ClockOutRecordDialog open={clockOutRecordDialogOpen} />
      ) : null}

      {locationMustOpen ? (
        <LocationMust open={locationMustOpen} project={locationMustProject} />
      ) : null}

      {proximityToClockInRequiredDialogOpen ? (
        <ProximityToClockInRequiredDialog open={proximityToClockInRequiredDialogOpen} project={proximityToClockInRequiredDialogProject} />
      ) : null}

      {isRecordAlreadyClockedInDialogOpen ? (
        <RecordAlreadyClockedInDialog />
      ) : null}
    </>
  );
}

export default RecordDialogContainer;
